// External imports
import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { closeNavMenu } from './features/NavMenu';

// Internal imports
import Header from './components/Header';
import NavMenu from './components/NavMenu';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import Reader from './components/Reader';
import SearchBar from './components/SearchBar';
import Backdrop from './components/Backdrop';

export default function App() {
  const [headerHeight, setHeaderHeight] = useState();
  const location = useLocation();
  const isMainPage = location.pathname === '/';

  useEffect(() => {
    const header = document.getElementById('header');
    if (header) {
      setHeaderHeight(header.offsetHeight);
    }
  }, []);

  return (
    <>
      <Header />
      <NavMenu headerHeight={headerHeight} />
      <Backdrop headerHeight={headerHeight} />
      <SearchBar headerHeight={headerHeight}/>
      <Reader headerHeight={headerHeight} />
      {isMainPage ? <HomePage headerHeight={headerHeight} /> : <Outlet />}
      <Footer />
    </>
  );
}
